import angular from 'angular';
import { IFlowModelCommandDataPascalCase } from '@Shared.Angular/@types/core/contracts/commands/modeler/flowModelCommandData';
import { IModelerProcessDetailDtoPascalCase } from '@Shared.Angular/@types/core/contracts/queryModel/modeler/modelerProcessDetailDto';
import FlowModelType from '@Shared.Angular/@types/core/contracts/constants/flowModelType';
import { Guid } from '@Shared.Angular/@types/guid';
import { Services } from '@Shared.Angular/@types/services';
import type { CreationHubFlowModelDetails } from '../runner.creation-hub/components/CreationHubFlowModelDetailsPanel';

export class CreationHubService {
  public static $inject = [
    'workflowModelFactory',
    'modelerApiService',
    'sessionService'
  ];

  constructor(
    private workflowModelFactory: Services.WorkflowModelFactory,
    private modelerApiService: Services.ModelerApiService,
    private sessionService: Services.SessionService
  ) {}

  public createDraftFlowModel(
    flowModelType: FlowModelType,
    details: CreationHubFlowModelDetails,
    isAiGenerated: boolean
  ): angular.IPromise<Guid> {
    return this.workflowModelFactory
      .createFlowModel(details.name, details.description)
      .then((workflow) => {
        workflow.FlowModelType = flowModelType;
        workflow.CategoryId = details.categoryId || null;
        workflow.ProcessDetail = this.buildProcessDetail(details);

        const user = this.sessionService.getUser();
        const payload: IFlowModelCommandDataPascalCase = {
          Id: workflow.Id,
          FlowModelType: workflow.FlowModelType,
          Name: workflow.Name,
          Description: workflow.Description,
          CustomPlaceholder: workflow.CustomPlaceholder || '',
          Category: workflow.Category || '',
          CategoryId: workflow.CategoryId,
          Active: workflow.Active,
          FlowSchema: workflow.FlowSchema,
          CreatedById: workflow.CreatedById,
          BusinessId: workflow.BusinessId,
          CurrentUserId: user.id,
          LastModifiedById: workflow.LastModifiedById || user.id,
          BusinessName: workflow.BusinessName || '',
          CreatedDate: workflow.CreatedDate,
          UpdatedDate: workflow.UpdatedDate,
          BackgroundColour: workflow.BackgroundColour || null,
          Nodes: workflow.Nodes as any,
          ProcessDetail: workflow.ProcessDetail,
          Tags: [],
          IsAiGenerated: isAiGenerated
        };

        return this.modelerApiService
          .addWorkflow(payload)
          .then((response) => response.data.Id);
      });
  }

  private buildProcessDetail(
    details: CreationHubFlowModelDetails
  ): IModelerProcessDetailDtoPascalCase {
    return {
      Id: null,
      Objective: details.objective || '',
      Background: details.background || '',
      ProcessInput: details.processInput || '',
      ProcessOutput: details.processOutput || '',
      TriggerInput: details.triggerInput || '',
      ProcessOwner: null
    };
  }
}

angular
  .module('flowingly.runner.services')
  .service('creationHubService', CreationHubService);

export type CreationHubServiceType = InstanceType<typeof CreationHubService>;
